import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getSavedBillsDetails = (id: string) => {
    return axiosPrivate.get(`/bills/api/v1/bills/${id}/saved_bills_details`);
}